import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import checkLinkedEmployee from "@/router/middlewares/checkLinkedEmployee";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
    {
        path: '/holidays',
        name: 'HolidayOverview',
        component: () => import(/* webpackChunkName: "holidays-view" */ '@/modules/holidays/components/HolidayOverview'),
        meta: {
            moduleId: 'holidays',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
            preloads: ['rights/actingUserHasRight/WORK_URLAUBS_BERECHTIGUNG_GENERELL'],
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/holidays/:id',
        name: 'HolidayForm',
        component: () => import(/* webpackChunkName: "holidays-form" */ '@/modules/holidays/components/HolidayForm'),
        meta: {
            moduleId: 'holidays',
            registries: ['configurations/holidays'],
            preloads: ['rights/actingUserHasRight/WORK_URLAUBS_BERECHTIGUNG_GENERELL'],
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/holidayEntitlement',
        name: 'HolidayEntitlementView',
        component: () => import(/* webpackChunkName: "holiday-entitlement-view" */ '@/modules/holidays/components/entitlement/HolidayEntitlementView'),
        meta: {
            moduleId: 'holidayEntitlement',
        },
        beforeEnter: checkLinkedEmployee
    },
    {
        path: '/holidayEntitlements',
        name: 'HolidayEntitlementsView',
        component: () => import(/* webpackChunkName: "holiday-entitlement-view" */ '@/modules/holidays/components/entitlement/HolidayEntitlementsView'),
        meta: {
            moduleId: 'holidayEntitlements',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
            preloads: ['rights/actingUserHasRight/WORK_Urlaubsanspruch_Verwaltung'],
        },
        beforeEnter: checkLinkedEmployee
    },
    {
        path: '/holidayEntitlements/:id',
        name: 'HolidayEntitlementForm',
        component: () => import(/* webpackChunkName: "holidays-form" */ '@/modules/holidays/components/entitlement/HolidayEntitlementForm'),
        meta: {
            moduleId: 'holidayEntitlements',
            preloads: ['rights/actingUserHasRight/WORK_Urlaubsanspruch_Verwaltung'],
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/holidaydeputies',
        name: 'HolidayDeputyView',
        component: () => import(/* webpackChunkName: "holidaydeputy-view" */ '@/modules/holidays/components/deputy/HolidayDeputyView'),
        meta: {
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
            moduleId: 'deputies'
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/holidaydeputies/:id',
        name: 'HolidayDeputyForm',
        component: () => import(/* webpackChunkName: "holidaydeputy-form" */ '@/modules/holidays/components/deputy/HolidayDeputyForm'),
        meta: {moduleId: 'deputies'},
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/holidayapprovals',
        name: 'HolidayApprovalView',
        component: () => import(/* webpackChunkName: "holidayapproval-view" */ '@/modules/holidays/components/approval/HolidayApprovalView'),
        meta: {
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
            moduleId: 'approval'
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/holidayapprovals/:id',
        name: 'HolidayApprovalForm',
        component: () => import(/* webpackChunkName: "holidayapproval-form" */ '@/modules/holidays/components/approval/HolidayApprovalForm'),
        meta: {moduleId: 'approval'},
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/holidaybans',
        name: 'HolidayBanView',
        component: () => import(/* webpackChunkName: "holidaybans-view" */ '@/modules/holidays/components/ban/HolidayBanView'),
        meta: {
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
            moduleId: 'holidaybans',
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/holidaybans/:id',
        name: 'HolidayBanForm',
        component: () => import(/* webpackChunkName: "holidaybans-form" */ '@/modules/holidays/components/ban/HolidayBanForm'),
        meta: {
            moduleId: 'holidaybans',
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/holiday-ban-years',
        name: 'HolidayBanCalendarView',
        component: () => import(/* webpackChunkName: "holiday-ban-calendar-view" */ '@/modules/holidays/components/ban/HolidayBanCalendarView'),
        meta: {
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
            moduleId: 'holidayBanCalendar',
        },
        beforeEnter: checkAuthenticated
    }
]
